import { render } from "./NewAccount.vue?vue&type=template&id=05ad5427&scoped=true&ts=true"
import script from "./NewAccount.vue?vue&type=script&lang=ts"
export * from "./NewAccount.vue?vue&type=script&lang=ts"

import "./NewAccount.vue?vue&type=style&index=0&id=05ad5427&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ad5427"]])

export default __exports__